import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

import { AuthService } from 'src/app/util/services/auth.service';
import { TokenStorageService } from '../../util/services/token-storage.service';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/util/services/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  isLoggedIn = false;
  roles: string[] = [];

  constructor(
    private formBuilder: FormBuilder, 
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private notificationService: NotificationService,
    private translate: TranslateService) { }

  ngOnInit() {
    this.createFormInputs();
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.roles = this.tokenStorage.getUser().roles;
      this.router.navigate(['']);
    }
  }

  createFormInputs() {
    this.form = this.formBuilder.group(
      {
        username          : new FormControl('', [Validators.required]),
        password 		      : new FormControl('', [Validators.required])
      });
 }

  onSubmit(event: Event) {
    event.preventDefault();

    this.authService.login(this.form.value).subscribe(res => {
        this.tokenStorage.saveToken(res.accessToken);
        this.tokenStorage.saveUser(res);
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.reloadPage();
      },
      () => {
        this.notificationService.showError(this.translate.instant('SIGN_IN.ERROR'), 5);
      }
    );
  }

  reloadPage() {
    this.router.navigate(['']);
    window.location.reload();
  }
}
